// @ts-nocheck
import React from 'react'
import {Link} from 'react-router';
import styles from './TopBar.module.css'

function BackButton(props) {
    let button = ""
    if (props.hasBackButton || (props.backButtonUsers && props.backButtonUsers.includes(props.user.role))) {
        button = (
            <Link to={`${props.url}`}>
                <div className={styles.backButton}>
                    <span aria-hidden="true">‹</span>
                </div>
            </Link>
        )
    }
    return button
}

export default BackButton